import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.info.light,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  icon: {
    color: theme.palette.info.main,
    marginTop: 2,
    flexShrink: 0,
  },
  text: {
    color: theme.palette.info.dark,
    fontSize: '0.875rem',
  },
}))

export default useStyles
